const getCurrentUserConsults = state => {
  return state.currentUserConsults;
}

export default {
  getCurrentUserConsults
}
